
    import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/utility/js/no-focusable-svg';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/utility/ie-warning/js/ie-warning';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/cookies/js/cookies';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/bookmark/js/bookmark';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/drop-block/js/drop-block';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/modal/js/modal';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/alert-popup/js/alert-popup';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/components/accordion/js/accordion';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/components/back-to-top/js/back-to-top';

import QuickSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/widgets/quick-search/js/quick-search';
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/ad-placeholder/js/ad-placeholder';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/multi-search/js/multi-search';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/raa/js/raa';

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/register/js/register';

import mobileMenuMain from './groups/_mobile-menu';
import stickyMain from './groups/_sticky';
const main = (UX) => {
    const $dropBlock = Array.prototype.slice.call(document.querySelectorAll('[data-db-target-for]')),
        $modal = Array.prototype.slice.call(document.getElementsByClassName('modal')),
        $alertPopup = Array.prototype.slice.call(document.getElementsByClassName('ux-alert-container')),
        $accordion = Array.prototype.slice.call(document.getElementsByClassName('accordion')),
        $backToTop = Array.prototype.slice.call(document.getElementsByClassName('back-to-top')),
        $quickSearch = Array.prototype.slice.call(document.getElementsByClassName('quick-search')),
        $adplaceholder = Array.prototype.slice.call(document.getElementsByClassName('js__toggleAdForm')),
        $multiSearch = Array.prototype.slice.call(document.getElementsByClassName('multi-search'))

try {
        UX.noFocusableSVG.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropBlock.length ) {
            UX.dropBlock.init($dropBlock);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($modal.length ) {
            UX.modal.init($modal);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alertPopup.length ) {
            UX.alertPopup.init($alertPopup);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accordion.length ) {
            UX.accordion.init($accordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($backToTop.length ) {
            UX.backToTop.init($backToTop);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($quickSearch.length ) {
            UX.quickSearch = $quickSearch
                .map(item=>new QuickSearch(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($adplaceholder.length ) {
            UX.adplaceholder.init($adplaceholder);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($multiSearch.length ) {
            UX.multiSearch.init($multiSearch);
        }
    } catch (err) {
        console.error(err);
    }
    
mobileMenuMain(UX);

stickyMain(UX);

}

    export default main;
        